module.exports = __webpack_public_path__ + "img/6.76f4ed16.png";